import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class EnaioUserPrefs {
    raw: OrdinaryObject<string>;
}
